import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
// import { cacheInterceptor } from './interceptors/cache.interceptor';
import { LanguageService } from './services/language.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideStore } from '@ngrx/store';
import { cartReducer } from './store/cart/cart.reducer';
import { adminCartReducer } from './store/admin-cart/admin-cart.reducer';
import { packageItemReducer } from './store/order/package-order/package-item.reducer';
import { confirmPackageReducer } from './store/order/confirm-package-order/confirm-package.reducer';
import { DATE_TIME_DISPLAY_FORMAT } from './shared/utils/date-format';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideClientHydration(withEventReplay()),
    provideAppInitializer(() => {
      const languageService = inject(LanguageService);
      languageService.initLocale();
    }),
    provideAnimations(),
    // A bare `| date` renders the approved dd/MM/yyyy hh:mm a format (AM/PM, or ص/م in Arabic) everywhere
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: DATE_TIME_DISPLAY_FORMAT } },
    provideStore({
      cartData: cartReducer,
      adminCartData: adminCartReducer,
      packageItems: packageItemReducer,
      confirmPackage: confirmPackageReducer,
    }),
  ],
};
